import { makeRequest } from '@/base/MaRequestPooler.js'

/**
 * Returns startup data for play store.
 * @param trackId
 * @returns {Promise<any>}
 */
export function getPlayStartupData(trackId) {
  return makeRequest(`/account/store-account/app/${trackId}/management/startup-data`)
}

/**
 * Returns the latest editable versions for app store.
 * @param trackId
 * @returns {Promise<any>}
 */
export function getIosLatestEditableVersions(trackId) {
  return makeRequest(`/account/store-account/app/${trackId}/management/latest-versions`)
}

/**
 * Create new app version for app store.
 * @param trackId
 * @param data
 * @returns {Promise<any>}
 */
export function createIosNewAppVersion(trackId, data) {
  return makeRequest(`/account/store-account/app/${trackId}/management/version`, {
    method: 'POST',
    data,
  })
}

/**
 * Update data for app store.
 * @param trackId
 * @param data
 * @returns {Promise<any>}
 */
export function updateIosVersionLocalizations(trackId, data) {
  return makeRequest(`/account/store-account/app/${trackId}/management/version-localizations`, {
    method: 'POST',
    data,
  })
}
